import { defineStore } from 'pinia';
import StoreUser from '@/models/StoreUser';
import { pinia } from '@/stores/pinia';

export type PortalState = {
  sessionId: string | null;
  user: StoreUser | null;
  lastUseTime: Date;
  loading: boolean;
  opacity: number;
  maintenance: boolean;
  backgroundTheme: number;
};

export const usePortalStore = defineStore('portal', {
  state: (): PortalState => ({
    sessionId: null,
    user: null,
    lastUseTime: new Date(),
    loading: false,
    opacity: 0.46,
    maintenance: false,
    backgroundTheme: 1,
  }),
  actions: {
    setSessionId(sessionId: string | null) {
      this.sessionId = sessionId;
    },
    setUser(user: StoreUser | null) {
      this.user = user;
    },
    setLastUseTime(date: Date) {
      this.lastUseTime = date;
    },
    startLoading() {
      this.loading = true;
    },
    endLoading() {
      this.loading = false;
    },
    setOpacity(opacity: number) {
      this.opacity = opacity;
    },
    setMaintenance(maintenance: boolean) {
      this.maintenance = maintenance;
    },
    setBackgroundTheme(theme: number) {
      this.backgroundTheme = theme;
    },
  },
});

/** setup 外（StoreHelper / AuthHelper）から store にアクセスする */
export function getPortalStore() {
  return usePortalStore(pinia);
}
